export const ModalConst = {
  LOGIN: 'login',
  REGISTER: 'register',
  FORGOTTEN: 'forgotten',
  CONFIRM: 'confirm',
  VERIFICATION: 'verification',
};
